import { useResponsiveFontSize } from '@/components/Util/reactResponsiveDimensions';
import { Platform, StyleSheet, View } from 'react-native';
import { Text } from '@/components/Text';
import ResponsiveTextWeb from './ResponsiveTextWeb';

const styles = StyleSheet.create({
  textStyle: {
    fontSize: 100,
    textAlign: 'center',
  },
  container: {
    justifyContent: 'center', // Centered horizontally
    alignItems: 'center', // Centered vertically
    width: '100%',
    height: '100%',
    textAlign: 'center',
  },
});

function ResponsiveText({
  children,
  style,
  fontSize,
  isFullWidth,
  className,
  stylesTw,
}) {
  let isWeb = Platform.OS === 'web';

  return isWeb ? (
    <View style={styles.container}>
      <ResponsiveTextWeb
        stylesTw={stylesTw}
        className={className}
        style={[styles.textStyle, style && style]}
        fontSize={fontSize ?? useResponsiveFontSize(5)}
        isFullWidth={true}
      >
        {children}
        {className}
      </ResponsiveTextWeb>
    </View>
  ) : (
    <View style={styles.container}>
      <Text
        stylesTw={stylesTw}
        adjustsFontSizeToFit={true}
        numberOfLines={1}
        style={[styles.textStyle, style && style]}
        className={className}
        isResponsiveText={true}
      >
        {children}
      </Text>
      {Platform.OS === 'android' && <Text>{'\u00A0'}</Text>}
    </View>
  );
}

export default ResponsiveText;
